export default {
    active_requirement_orders: "Белсенді наряд-тапсырыстар",
    add_laboratory_service: "Зертханалық қызметті қосу",
    after_finished_fixed: "Аяқтағаннан кейін",
    can_have_dental_work: "Тіс техникалық жұмыстарды қамтуы мүмкін",
    cannot_change_services_that_already_have_laboratory_services_attached: "Олармен байланысты зертханалық жұмысы бар қызметтерді жұмысқа тапсырыстан жоя алмайсыз.",
    carcass: "Жақтау",
    deleted_from_treatment: "Емдеуден шығарылды",
    delivery_date: "Тапсыру күні",
    dental_work: "Тіс техникалық жұмыстар",
    do_you_confirm_cancel_laboratory_order: "Жұмысқа тапсырыстан шынымен бас тартқыңыз келе ме?",
    do_you_confirm_laboratory_order_finish: "Сіз пациентке жұмыс тапсырылғанын растайсыз ба? Расталғаннан кейін дәрігерге жалақы есептеледі, ал осы наряд-тапсырыс бойынша өзгерістер мүмкін болмайды.",
    do_you_confirm_laboratory_order_finish2: "Жұмыстың науқасқа тапсырылғанын растайсыз ба? Аяқталған жұмысқа тапсырысқа өзгертулер енгізу мүмкін емес. Өңдеу үшін құжатты жариялаудан бас тарту керек.",
    executor: "Орындаушы",
    faintly: "Әлсіз",
    field_is_required: "Міндетті өріс",
    fitting_date: "Өлшеу күні",
    full: "Толық",
    immediately: "Бірден",
    in_clinic: "Клиникада",
    in_lab: "Зертханада",
    initiated: "Бастамашылық етілген",
    intermediate_part_design: "Аралық дизайн",
    laboratories: "Зертханалар",
    laboratory: "Зертхана",
    laboratory_service: "Зертханалық қызмет",
    LaboratoryOrder: "Жұмыс тәртібі",
    logics_on_laboratory_services_deduction: "Жұмыс тәртібі бойынша зертханалық жұмысты азайту логикасы",
    moderately: "Орташа",
    must_have_dental_work: "Міндетті түрде тіс техникалық жұмыстарды қамтиды",
    no_dental_work_needed_for_selected_services: "Таңдалған қызметтер үшін тіс техникалық жұмыстар талап етілмейді",
    no_services: "Қызметтер жоқ",
    order_number: "Наряд нөмірі",
    paint_restorations: "Қалпына келтірулерді бояңыз",
    panorama: "Панорама",
    pay_all: "Барлығын төлеу",
    requirement_order: "Наряд - тапсырыс",
    select_from_price: "Прайстан таңдау",
    send_to_laboratory_via_messenger: "Мессенджер арқылы зертханаларға жіберіңіз",
    shoulder: "Иық",
    simplified: "Жеңілдетілген",
    total_orders_for_the_amount: "Сомаға барлық нарядтар",
    when_changeing_laboratory_all_selected_services_will_be_removed_continue: "Зертхананы ауыстырған кезде барлық таңдалған қызметтер тізімнен жойылады. Жалғастыру керек пе?",
    without_attachment_to_tooth: "Тіске байланыстырусыз"
}
